import BaseService from '@/services/BaseService';

class BillingService extends BaseService {
    getAll = (filters) => this.post('/agency/billinghistory', filters || { });
}

export default new BillingService();
